/**
 * Zitadel Authentication Module
 *
 * Provides OIDC authentication with Zitadel for tenant-ui.
 * Uses Authorization Code + PKCE flow for secure client-side auth.
 *
 * @example
 * ```tsx
 * // In layout.tsx
 * import { AuthProvider } from '@/lib/auth';
 *
 * export default function Layout({ children }) {
 *   return (
 *     <AuthProvider>
 *       {children}
 *     </AuthProvider>
 *   );
 * }
 *
 * // In components
 * import { useAuth } from '@/lib/auth';
 *
 * function MyComponent() {
 *   const { isAuthenticated, login, logout, tenantSlug } = useAuth();
 *   // ...
 * }
 * ```
 */

import { createReauthHelpers } from '@repo/auth/reauth';

// Re-export from shared auth package
export { useAuth, createUserManager } from '@repo/auth';
export type {
  AuthContextType,
  AuthState,
  LoginOptions,
  ZitadelUserProfile,
  AuthConfig,
} from '@repo/auth';

// App-specific AuthProvider with config
export { AuthProvider } from './auth-provider';

// App-specific config
export { getUserManager, getZitadelConfig } from './config';

// RTK Query reauth utility (shared implementation, bound to app-specific UserManager)
import { getUserManager } from './config';

export const { withReauth, getValidAccessToken } =
  createReauthHelpers(getUserManager);
